import { TtAdvancedSearchLayoutConfig } from './tt-advanced-search-layout.config';

export default {
  layouts: {
    MrAdvancedSearchLayoutConfig: TtAdvancedSearchLayoutConfig,
  }
};
